import { LinkRouterProps } from '@anytag/router';
import { useMatchPaths } from '@anytag/shared-hooks';

// TODO: we are moving to new Chat UI but still limit within influencer search pages
// We will remove this hook after new Chat UI is ready for all pages
export const useInfluencerSearchPathnames = () => {
  const { matchPaths } = useMatchPaths();

  const influencerSearchPaths = [
    '/influencers/search',
    '/influencers/search/instagram',
    '/influencers/search/youtube',
    '/influencers/search/tiktok',
    '/influencers/search/douyin',
    '/influencers/search/facebook',
    '/influencers/search/facebook_page',
    '/influencers/search/twitter',
    '/influencers/search/threads'
  ] as const satisfies LinkRouterProps['to'][];
  const engagementInfluencerSearchPaths = [
    '/engagement/$id/influencer',
    '/engagement/$id/influencer/instagram',
    '/engagement/$id/influencer/youtube',
    '/engagement/$id/influencer/tiktok',
    '/engagement/$id/influencer/douyin',
    '/engagement/$id/influencer/facebook',
    '/engagement/$id/influencer/facebook_page',
    '/engagement/$id/influencer/twitter',
    '/engagement/$id/influencer/threads',
    '/engagement/$id/influencer/campaigns',
    '/engagement/$id/influencer/packages',
    '/engagement/$id/influencer/posts'
  ] as const satisfies LinkRouterProps['to'][];
  const isInfluencersSearchPage = matchPaths(influencerSearchPaths);
  const isEngagementSearchPage = matchPaths(engagementInfluencerSearchPaths);
  const supportedInfluencerSearchPaths = [...influencerSearchPaths, ...engagementInfluencerSearchPaths];
  const isSupportedChatAIPaths = matchPaths([
    '/influencers/search',
    '/influencers/search/tiktok',
    '/influencers/search/youtube',
    '/influencers/search/instagram',
    '/engagement/$id/influencer',
    '/engagement/$id/influencer/tiktok',
    '/engagement/$id/influencer/youtube',
    '/engagement/$id/influencer/instagram'
  ]);

  return {
    isSupportedChatAIPaths,
    isEngagementSearchPage,
    isInfluencersSearchPage,
    influencerSearchPaths,
    engagementInfluencerSearchPaths,
    supportedInfluencerSearchPaths
  };
};
